"use client";

import styled from "styled-components";

export const LabelInputComponent = styled.label`
  font-weight: 400;
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--labelColor);
  line-height: 24px;
  margin-bottom: 4px;
  display: block;
  align-items: center;
  gap: 10px;
`;

export const DescriptionLabel = styled.span`
  font-family: "Roboto Light";
  font-size: 12px;
  line-height: 12px;
  color: var(--labelColor);
  display: block;
  margin-bottom: 10px;
`;
